export const iconFontAwesomeReligionKaaba = (
	<i className="fa-solid fa-kaaba"></i>
);
